import { createFileRoute } from "@tanstack/react-router";
import { PreparePlate } from "../../app/views/pcr/preparePlate";

export const Route = createFileRoute("/pcr/prepare")({
  component: PreparePlate,
});
